import React from 'react';
import * as R from 'ramda';
import { array, object, number, string, bool } from 'prop-types';

import AssigneesList from './assignees-list';
import { AssigneeItem } from './assignees-list/assignees-list-item';
import { AssigneesListWrapper } from './assignees-list/styled-components';
import {
  RequestAssigneesWrapper,
} from './styled-components';
import ManageAssignees from '../../../../containers/requests-list-item/request-assignees';


export function RequestAssignees({
  users,
  requestId,
  assignees,
  assigneesVisibleLimit,
  requestTasks,
  onRequest,
}) {
  const visibleAssignees = assignees.slice(0, assigneesVisibleLimit);
  const assigneesLength = assignees.length;

  const visibleAssigneesReversed = visibleAssignees.reverse();

  const width = onRequest ? '37px' : '25px';
  const height = onRequest ? '37px' : '25px';

  return (
    <RequestAssigneesWrapper
      assigneesLenght={assigneesLength}
      content={
        <ManageAssignees
          users={users}
          requestId={requestId}
          assignees={assignees}
          requestTasks={requestTasks}
        />
      }
      {...(onRequest ? { placement: 'bottomLeft' } : {})}
    >
      {!R.isEmpty(visibleAssignees)
        ? <AssigneesList
          assigneesLenght={assigneesLength}
          users={users}
          assignees={visibleAssigneesReversed}
          assigneesVisibleLimit={assigneesVisibleLimit}
          assigneeIconStyle={{
            width,
            height,
            ...(visibleAssignees.length > 1 && { marginRight: onRequest ? '5px' : '-12px' }),
          }}
        />
        : (
          <AssigneesListWrapper>
            <AssigneeItem
              unassigned
              assigneeIconStyle={{ marginRight: onRequest ? '5px' : '-15px', width, height }}
            />
          </AssigneesListWrapper>
        )
      }
      {!R.isEmpty(visibleAssignees)}
    </RequestAssigneesWrapper>
  );
}

RequestAssignees.propTypes = {
  users: object.isRequired,
  assignees: array.isRequired,
  requestId: string.isRequired,
  assigneesVisibleLimit: number,
  requestTasks: array,
  onRequest: bool,
};

RequestAssignees.defaultProps = {
  assigneesVisibleLimit: 3,
  requestTasks: null,
  onRequest: false,
};



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/index.js